import {StyleSheet} from 'react-native';

import {variants} from '/component/base/Text/Text.style';
import {indent} from '/constant/layout.constant';
import {onyx} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  header: {
    color: onyx,
    lineHeight: 33,
    fontWeight: '600',
    textAlign: 'center',
  },
  text: {
    marginTop: indent / 2,
    marginHorizontal: indent / 2,
    color: onyx,
    textAlign: 'center',
    ...variants.heading,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: indent,
    zIndex: 1000,
  },
  button: {
    flex: 1,
    paddingVertical: indent * 0.75,
    zIndex: 1000,
  },
  cancelButton: {
    borderColor: onyx,
  },
  mainButton: {
    backgroundColor: onyx,
  },
  buttonText: {
    textTransform: 'capitalize',
  },
  closeIcon: {
    fontSize: 20,
  },
  iconContainer: {
    marginRight: 10,
    alignSelf: 'flex-end',
  },
});
